import dustinWilliamsonAvatar from "../../../assets/img/demo/dustin-williamson-avatar.png";
import darrellMckinneyAvatar from "../../../assets/img/demo/darrell-mckinney-avatar.png";
import eduardoMilesAvatar from "../../../assets/img/demo/eduardo-miles-avatar.png";
import brandonPenaAvatar from "../../../assets/img/demo/brandon-pena-avatar.png";
import jacobHawkinsAvatar from "../../../assets/img/demo/jacob-hawkins-avatar.png";
import team1Logo from "../../../assets/img/demo/team-logo-1.png";
import team2Logo from "../../../assets/img/demo/team-logo-2.png";

const row1 = {
    name: 'Dustin Williamson',
    // The image source of player avatar.
    avatar: dustinWilliamsonAvatar,
    team: 'Liverpool',
    position: ' CF,RAMF, RWF',
    age: '20',
    marketValue: '$2M',
    matchesPlayed: '203',
    minutesPlayed: '3003',
    birthCountry: 'Brazil',
    passportCountry: 'Brazil',
    foot: 'Right',
    height: '165',
    weight: '60',
    onLoan: 'No',
    rank: 'down',
    profile: {
        score: 83,
        value: "$30M",
        wage: "10M",
    },
    keyStatsFrom: {
        overallCareer: {
            goalsScored: {
                value: 23,
                track: {
                    status: 'up',
                    value: "3"
                },
            },
            shootAccuracy: {
                value:'86%',
                track: {
                    status: 'down',
                    value: "2%"
                },
            },
            passingAccuracy: {
                value: '79%',
                track: {
                    status: 'up',
                    value: "3%"
                },
            },
            tackleSuccessRate: {
                value: '67%',
            },
        },
    },
    playedPositionMap: {
        cf: {
            low: [
                // The Coordinates of non overlapping polygon.
                {x: 5, y: 5},
                {x: -5, y: 5},
                {x: -5, y: -5},
                {x: 5, y: -5},
            ],
            medium: [
                {x: 6, y: 6},
                {x: -6, y: 6},
                {x: -6, y: -6},
                {x: 6, y: -6},
            ],
            high: [
                {x: 7, y: 7},
                {x: -7, y: 7},
                {x: -7, y: -7},
                {x: 7, y: -7},
            ],
        },
        ramf: {
            low: [
                {x: 5, y: 5},
                {x: -5, y: 5},
                {x: -5, y: -5},
                {x: 5, y: -5},
            ],
            medium: [
                {x: 6, y: 6},
                {x: -6, y: 6},
                {x: -6, y: -6},
                {x: 6, y: -6},
            ],
            high: [
                {x: 7, y: 7},
                {x: -7, y: 7},
                {x: -7, y: -7},
                {x: 7, y: -7},
            ],
        },
        rwf: {
            low: [
                {x: 5, y: 5},
                {x: -5, y: 5},
                {x: -5, y: -5},
                {x: 5, y: -5},
            ],
            medium: [
                {x: 6, y: 6},
                {x: -6, y: 6},
                {x: -6, y: -6},
                {x: 6, y: -6},
            ],
            high: [
                {x: 7, y: 7},
                {x: -7, y: 7},
                {x: -7, y: -7},
                {x: 7, y: -7},
            ],
        }
    },
    performanceAndSkillsScore: {
        attack: {
            crossing: 64,
            finishing: 76,
            heading: 30,
            shortPass: 95,
            volleys: 69,
        },
        skill: {
            dribbling: 55,
            curve: 95,
            freeKick: 56,
            longPassing: 65,
            ballControl: 64,
        },
        movement: {
            acceleration: 56,
            sprintSpeed: 62,
            agility: 62,
            reaction: 32,
            balance: 79,
        },
        power: {
            shotPower: 16,
            jumping: 62,
            stamina: 17,
            strength: 37,
            longShots: 62,
        },
        mental: {
            aggression: 62,
            interceptions: 95,
            positioning: 14,
            vision: 64,
            penalties: 43,
            composure: 73,
        },
        defending: {
            marking: 69,
            standingTackles: 36,
            slidingTackles: 42,
        },
        goalKeeping: {
            diving: 34,
            handling: 64,
            kicking: 69,
            positioning: 37,
            reflexes: 91,
        },
        specialities: {
            shotPower: 62,
            longShotTaker: 79,
            speedster: 37,
            dribbler: 19,
            distanceShooter: 76,
            passer: 97,
        },
    },
    teamAndTransfer: {
        currentTeam: {
            name: 'Liverpool FC',
            description: 'Contract Expires on March 2019',
            logo: team1Logo,
        },
        transferredFrom: {
            name: 'Chelsea FC',
            description: 'Transfered for $10 M',
            logo: team2Logo,
        },
    },
    bookmarked: false,
    selected: false,
};
const row2 = {
    name: 'Darrell Mckinney',
    avatar: darrellMckinneyAvatar,
    team: 'Liverpool',
    position: ' CF,RAMF, RWF',
    age: '20',
    marketValue: '$2M',
    matchesPlayed: '203',
    minutesPlayed: '3003',
    birthCountry: 'Slovakia',
    passportCountry: 'Brazil',
    foot: 'Right',
    height: '165',
    weight: '60',
    onLoan: 'No',
    rank: 'down',
    profile: {
        score: 83,
        value: "$30M",
        wage: "10M",
        avatar: dustinWilliamsonAvatar,
    },
    keyStatsFrom: {
        overallCareer: {
            goalsScored: {
                value: 23,
                track: {
                    status: 'up',
                    value: "3"
                },
            },
            shootAccuracy: {
                value:'86%',
                track: {
                    status: 'down',
                    value: "2%"
                },
            },
            passingAccuracy: {
                value: '79%',
                track: {
                    status: 'up',
                    value: "3%"
                },
            },
            tackleSuccessRate: {
                value: '67%',
            },
        },
    },
    playedPositionMap: {
        cf: {
            low: [
                {x: 5, y: 5},
                {x: -5, y: 5},
                {x: -5, y: -5},
                {x: 5, y: -5},
            ],
            medium: [
                {x: 6, y: 6},
                {x: -6, y: 6},
                {x: -6, y: -6},
                {x: 6, y: -6},
            ],
            high: [
                {x: 7, y: 7},
                {x: -7, y: 7},
                {x: -7, y: -7},
                {x: 7, y: -7},
            ],
        },
        ramf: {
            low: [
                {x: 5, y: 5},
                {x: -5, y: 5},
                {x: -5, y: -5},
                {x: 5, y: -5},
            ],
            medium: [
                {x: 6, y: 6},
                {x: -6, y: 6},
                {x: -6, y: -6},
                {x: 6, y: -6},
            ],
            high: [
                {x: 7, y: 7},
                {x: -7, y: 7},
                {x: -7, y: -7},
                {x: 7, y: -7},
            ],
        },
        rwf: {
            low: [
                {x: 5, y: 5},
                {x: -5, y: 5},
                {x: -5, y: -5},
                {x: 5, y: -5},
            ],
            medium: [
                {x: 6, y: 6},
                {x: -6, y: 6},
                {x: -6, y: -6},
                {x: 6, y: -6},
            ],
            high: [
                {x: 7, y: 7},
                {x: -7, y: 7},
                {x: -7, y: -7},
                {x: 7, y: -7},
            ],
        }
    },
    performanceAndSkillsScore: {
        attack: {
            crossing: 64,
            finishing: 76,
            heading: 30,
            shortPass: 95,
            volleys: 69,
        },
        skill: {
            dribbling: 55,
            curve: 95,
            freeKick: 56,
            longPassing: 65,
            ballControl: 64,
        },
        movement: {
            acceleration: 56,
            sprintSpeed: 62,
            agility: 62,
            reaction: 32,
            balance: 79,
        },
        power: {
            shotPower: 16,
            jumping: 62,
            stamina: 17,
            strength: 37,
            longShots: 62,
        },
        mental: {
            aggression: 62,
            interceptions: 95,
            positioning: 14,
            vision: 64,
            penalties: 43,
            composure: 73,
        },
        defending: {
            marking: 69,
            standingTackles: 36,
            slidingTackles: 42,
        },
        goalKeeping: {
            diving: 34,
            handling: 64,
            kicking: 69,
            positioning: 37,
            reflexes: 91,
        },
        specialities: {
            shotPower: 62,
            longShotTaker: 79,
            speedster: 37,
            dribbler: 19,
            distanceShooter: 76,
            passer: 97,
        },
    },
    teamAndTransfer: {
        currentTeam: {
            name: 'Liverpool FC',
            description: 'Contract Expires on March 2019',
            logo: team1Logo,
        },
        transferredFrom: {
            name: 'Chelsea FC',
            description: 'Transfered for $10 M',
            logo: team2Logo,
        },
    },
    bookmarked: false,
    selected: false,
};
const row3 = {
    name: 'Eduardo Miles',
    avatar: eduardoMilesAvatar,
    team: 'Liverpool',
    position: ' CF,RAMF, RWF',
    age: '20',
    marketValue: '$2M',
    matchesPlayed: '203',
    minutesPlayed: '3003',
    birthCountry: 'New Zealand',
    passportCountry: 'Brazil',
    foot: 'Right',
    height: '165',
    weight: '60',
    onLoan: 'No',
    rank: 'down',
    profile: {
        score: 83,
        value: "$30M",
        wage: "10M",
        avatar: dustinWilliamsonAvatar,
    },
    keyStatsFrom: {
        overallCareer: {
            goalsScored: {
                value: 23,
                track: {
                    status: 'up',
                    value: "3"
                },
            },
            shootAccuracy: {
                value:'86%',
                track: {
                    status: 'down',
                    value: "2%"
                },
            },
            passingAccuracy: {
                value: '79%',
                track: {
                    status: 'up',
                    value: "3%"
                },
            },
            tackleSuccessRate: {
                value: '67%',
            },
        },
    },
    playedPositionMap: {
        cf: {
            low: [
                {x: 5, y: 5},
                {x: -5, y: 5},
                {x: -5, y: -5},
                {x: 5, y: -5},
            ],
            medium: [
                {x: 6, y: 6},
                {x: -6, y: 6},
                {x: -6, y: -6},
                {x: 6, y: -6},
            ],
            high: [
                {x: 7, y: 7},
                {x: -7, y: 7},
                {x: -7, y: -7},
                {x: 7, y: -7},
            ],
        },
        ramf: {
            low: [
                {x: 5, y: 5},
                {x: -5, y: 5},
                {x: -5, y: -5},
                {x: 5, y: -5},
            ],
            medium: [
                {x: 6, y: 6},
                {x: -6, y: 6},
                {x: -6, y: -6},
                {x: 6, y: -6},
            ],
            high: [
                {x: 7, y: 7},
                {x: -7, y: 7},
                {x: -7, y: -7},
                {x: 7, y: -7},
            ],
        },
        rwf: {
            low: [
                {x: 5, y: 5},
                {x: -5, y: 5},
                {x: -5, y: -5},
                {x: 5, y: -5},
            ],
            medium: [
                {x: 6, y: 6},
                {x: -6, y: 6},
                {x: -6, y: -6},
                {x: 6, y: -6},
            ],
            high: [
                {x: 7, y: 7},
                {x: -7, y: 7},
                {x: -7, y: -7},
                {x: 7, y: -7},
            ],
        }
    },
    performanceAndSkillsScore: {
        attack: {
            crossing: 64,
            finishing: 76,
            heading: 30,
            shortPass: 95,
            volleys: 69,
        },
        skill: {
            dribbling: 55,
            curve: 95,
            freeKick: 56,
            longPassing: 65,
            ballControl: 64,
        },
        movement: {
            acceleration: 56,
            sprintSpeed: 62,
            agility: 62,
            reaction: 32,
            balance: 79,
        },
        power: {
            shotPower: 16,
            jumping: 62,
            stamina: 17,
            strength: 37,
            longShots: 62,
        },
        mental: {
            aggression: 62,
            interceptions: 95,
            positioning: 14,
            vision: 64,
            penalties: 43,
            composure: 73,
        },
        defending: {
            marking: 69,
            standingTackles: 36,
            slidingTackles: 42,
        },
        goalKeeping: {
            diving: 34,
            handling: 64,
            kicking: 69,
            positioning: 37,
            reflexes: 91,
        },
        specialities: {
            shotPower: 62,
            longShotTaker: 79,
            speedster: 37,
            dribbler: 19,
            distanceShooter: 76,
            passer: 97,
        },
    },
    teamAndTransfer: {
        currentTeam: {
            name: 'Liverpool FC',
            description: 'Contract Expires on March 2019',
            logo: team1Logo,
        },
        transferredFrom: {
            name: 'Chelsea FC',
            description: 'Transfered for $10 M',
            logo: team2Logo,
        },
    },
    bookmarked: false,
    selected: false,
};
const row4 = {
    name: 'Brandon Pena',
    avatar: brandonPenaAvatar,
    team: 'Liverpool',
    position: ' CF,RAMF, RWF',
    age: '20',
    marketValue: '$2M',
    matchesPlayed: '203',
    minutesPlayed: '3003',
    birthCountry: 'Anguilla',
    passportCountry: 'Brazil',
    foot: 'Right',
    height: '165',
    weight: '60',
    onLoan: 'No',
    rank: 'down',
    profile: {
        score: 83,
        value: "$30M",
        wage: "10M",
        avatar: dustinWilliamsonAvatar,
    },
    keyStatsFrom: {
        overallCareer: {
            goalsScored: {
                value: 23,
                track: {
                    status: 'up',
                    value: "3"
                },
            },
            shootAccuracy: {
                value:'86%',
                track: {
                    status: 'down',
                    value: "2%"
                },
            },
            passingAccuracy: {
                value: '79%',
                track: {
                    status: 'up',
                    value: "3%"
                },
            },
            tackleSuccessRate: {
                value: '67%',
            },
        },
    },
    playedPositionMap: {
        cf: {
            low: [
                {x: 5, y: 5},
                {x: -5, y: 5},
                {x: -5, y: -5},
                {x: 5, y: -5},
            ],
            medium: [
                {x: 6, y: 6},
                {x: -6, y: 6},
                {x: -6, y: -6},
                {x: 6, y: -6},
            ],
            high: [
                {x: 7, y: 7},
                {x: -7, y: 7},
                {x: -7, y: -7},
                {x: 7, y: -7},
            ],
        },
        ramf: {
            low: [
                {x: 5, y: 5},
                {x: -5, y: 5},
                {x: -5, y: -5},
                {x: 5, y: -5},
            ],
            medium: [
                {x: 6, y: 6},
                {x: -6, y: 6},
                {x: -6, y: -6},
                {x: 6, y: -6},
            ],
            high: [
                {x: 7, y: 7},
                {x: -7, y: 7},
                {x: -7, y: -7},
                {x: 7, y: -7},
            ],
        },
        rwf: {
            low: [
                {x: 5, y: 5},
                {x: -5, y: 5},
                {x: -5, y: -5},
                {x: 5, y: -5},
            ],
            medium: [
                {x: 6, y: 6},
                {x: -6, y: 6},
                {x: -6, y: -6},
                {x: 6, y: -6},
            ],
            high: [
                {x: 7, y: 7},
                {x: -7, y: 7},
                {x: -7, y: -7},
                {x: 7, y: -7},
            ],
        }
    },
    performanceAndSkillsScore: {
        attack: {
            crossing: 64,
            finishing: 76,
            heading: 30,
            shortPass: 95,
            volleys: 69,
        },
        skill: {
            dribbling: 55,
            curve: 95,
            freeKick: 56,
            longPassing: 65,
            ballControl: 64,
        },
        movement: {
            acceleration: 56,
            sprintSpeed: 62,
            agility: 62,
            reaction: 32,
            balance: 79,
        },
        power: {
            shotPower: 16,
            jumping: 62,
            stamina: 17,
            strength: 37,
            longShots: 62,
        },
        mental: {
            aggression: 62,
            interceptions: 95,
            positioning: 14,
            vision: 64,
            penalties: 43,
            composure: 73,
        },
        defending: {
            marking: 69,
            standingTackles: 36,
            slidingTackles: 42,
        },
        goalKeeping: {
            diving: 34,
            handling: 64,
            kicking: 69,
            positioning: 37,
            reflexes: 91,
        },
        specialities: {
            shotPower: 62,
            longShotTaker: 79,
            speedster: 37,
            dribbler: 19,
            distanceShooter: 76,
            passer: 97,
        },
    },
    teamAndTransfer: {
        currentTeam: {
            name: 'Liverpool FC',
            description: 'Contract Expires on March 2019',
            logo: team1Logo,
        },
        transferredFrom: {
            name: 'Chelsea FC',
            description: 'Transfered for $10 M',
            logo: team2Logo,
        },
    },
    bookmarked: false,
    selected: false,
};
const row5 = {
    name: 'Jacob Hawkins',
    avatar: jacobHawkinsAvatar,
    team: 'Liverpool',
    position: ' CF,RAMF, RWF',
    age: '20',
    marketValue: '$2M',
    matchesPlayed: '203',
    minutesPlayed: '3003',
    birthCountry: 'Djibouti',
    passportCountry: 'Brazil',
    foot: 'Right',
    height: '165',
    weight: '60',
    onLoan: 'No',
    rank: 'down',
    profile: {
        score: 83,
        value: "$30M",
        wage: "10M",
        avatar: dustinWilliamsonAvatar,
    },
    keyStatsFrom: {
        overallCareer: {
            goalsScored: {
                value: 23,
                track: {
                    status: 'up',
                    value: "3"
                },
            },
            shootAccuracy: {
                value:'86%',
                track: {
                    status: 'down',
                    value: "2%"
                },
            },
            passingAccuracy: {
                value: '79%',
                track: {
                    status: 'up',
                    value: "3%"
                },
            },
            tackleSuccessRate: {
                value: '67%',
            },
        },
    },
    playedPositionMap: {
        cf: {
            low: [
                {x: 5, y: 5},
                {x: -5, y: 5},
                {x: -5, y: -5},
                {x: 5, y: -5},
            ],
            medium: [
                {x: 6, y: 6},
                {x: -6, y: 6},
                {x: -6, y: -6},
                {x: 6, y: -6},
            ],
            high: [
                {x: 7, y: 7},
                {x: -7, y: 7},
                {x: -7, y: -7},
                {x: 7, y: -7},
            ],
        },
        ramf: {
            low: [
                {x: 5, y: 5},
                {x: -5, y: 5},
                {x: -5, y: -5},
                {x: 5, y: -5},
            ],
            medium: [
                {x: 6, y: 6},
                {x: -6, y: 6},
                {x: -6, y: -6},
                {x: 6, y: -6},
            ],
            high: [
                {x: 7, y: 7},
                {x: -7, y: 7},
                {x: -7, y: -7},
                {x: 7, y: -7},
            ],
        },
        rwf: {
            low: [
                {x: 5, y: 5},
                {x: -5, y: 5},
                {x: -5, y: -5},
                {x: 5, y: -5},
            ],
            medium: [
                {x: 6, y: 6},
                {x: -6, y: 6},
                {x: -6, y: -6},
                {x: 6, y: -6},
            ],
            high: [
                {x: 7, y: 7},
                {x: -7, y: 7},
                {x: -7, y: -7},
                {x: 7, y: -7},
            ],
        }
    },
    performanceAndSkillsScore: {
        attack: {
            crossing: 64,
            finishing: 76,
            heading: 30,
            shortPass: 95,
            volleys: 69,
        },
        skill: {
            dribbling: 55,
            curve: 95,
            freeKick: 56,
            longPassing: 65,
            ballControl: 64,
        },
        movement: {
            acceleration: 56,
            sprintSpeed: 62,
            agility: 62,
            reaction: 32,
            balance: 79,
        },
        power: {
            shotPower: 16,
            jumping: 62,
            stamina: 17,
            strength: 37,
            longShots: 62,
        },
        mental: {
            aggression: 62,
            interceptions: 95,
            positioning: 14,
            vision: 64,
            penalties: 43,
            composure: 73,
        },
        defending: {
            marking: 69,
            standingTackles: 36,
            slidingTackles: 42,
        },
        goalKeeping: {
            diving: 34,
            handling: 64,
            kicking: 69,
            positioning: 37,
            reflexes: 91,
        },
        specialities: {
            shotPower: 62,
            longShotTaker: 79,
            speedster: 37,
            dribbler: 19,
            distanceShooter: 76,
            passer: 97,
        },
    },
    teamAndTransfer: {
        currentTeam: {
            name: 'Liverpool FC',
            description: 'Contract Expires on March 2019',
            logo: team1Logo,
        },
        transferredFrom: {
            name: 'Chelsea FC',
            description: 'Transfered for $10 M',
            logo: team2Logo,
        },
    },
    bookmarked: false,
    selected: false,
};

const initialRows = Array.from(Array(25).keys())
    .map(i => JSON.parse(JSON.stringify([row1, row2, row3, row4, row5][Math.floor((Math.random() * 5))]))).map((row, index) => {
        return Object.assign({}, {...row, id: index});
    });


const handleSearch = (row, searchValue) => {
    const searchInRow = (row, text) => {
        return row.name.toLowerCase().includes(text.toLowerCase());
    };

    return searchValue === undefined || searchValue.length === 0 || searchInRow(row, searchValue);
};

const remoteData = (offset, limit, search, filters) => {
    const filtered = initialRows.filter((row) => handleSearch(row, search));

    return {
        rows: filtered.slice(offset - 1, offset - 1 + limit),
        totalRows: initialRows.length,
        filteredRows: filtered.length,
    };
};

export default initialRows;
export {remoteData, row1 as player};
